import { WorkDayConfig } from '../api/generated/data-contracts';
import { daysArray } from '../constants/defaultArrays';
import { PeriodDay } from '../types/PeriodDay';
import { TFunction } from 'i18next';

export const getPeriodDaysEnabled = (allPeriodDays: PeriodDay[], t: TFunction<'timesheet', undefined>, weekConfig: WorkDayConfig[]): PeriodDay[] => {
    const getPeriodDaysEnabled: PeriodDay[] = [];

    const enabledDays = new Set(
        weekConfig
            .filter(day => day.enabled)
            .map(day => day.name?.toLowerCase())
            .filter((name): name is string => !!name),
    );

    let index = 0;

    allPeriodDays.forEach(day => {
        const currentday = new Date(day.date);
        const dayName = currentday.toLocaleDateString('en-US', { weekday: 'long' }).toLowerCase();

        if (enabledDays.has(dayName)) {
            const originalName = daysArray[currentday.getDay()];
            // If t is null, it is because we have called this function from a place where we don't need translation
            // e.g. in TimePeriodGroupWeek.tsx
            const translatedDayName = t != null ? t(`common:days.${currentday.getDay()}`) : originalName;

            getPeriodDaysEnabled.push({
                id: index,
                date: new Date(currentday),
                originalName,
                translatedName: translatedDayName,
            });
            index++;
        }

        currentday.setDate(currentday.getDate() + 1);
    });

    return getPeriodDaysEnabled;
};

export const getPeriodDays = (startDate: Date, endDate: Date, t: TFunction<'timesheet', undefined>) => {
    const periodDaysArr: PeriodDay[] = [];
    const currentday = new Date(startDate);
    let index: number = 0;
    while (currentday <= endDate) {
        const days = daysArray;
        const translatedDays = [
            t('common:days.0'),
            t('common:days.1'),
            t('common:days.2'),
            t('common:days.3'),
            t('common:days.4'),
            t('common:days.5'),
            t('common:days.6'),
        ];
        const translatedDayName = translatedDays[currentday.getDay()];
        const dayName = days[currentday.getDay()];
        periodDaysArr.push({
            id: index,
            date: new Date(currentday),
            originalName: dayName,
            translatedName: translatedDayName,
        });
        index++;
        currentday.setDate(currentday.getDate() + 1);
    }

    return periodDaysArr;
};
